// Typelizer digest b633019a23979ad4c01db5e3243399d1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/duplicate */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/duplicate', params, options),
    method: 'post',
  }),
}
